export * from './copy-2-clipboard';
